import React, { Component } from 'react';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import { connect } from 'react-redux';

import PnrForm from '../view/pnrForm';
import IropsatcView from '../view/IropsatcView';

import Loading from '../scripts/components/global/loading-screen';
import storage from '../scripts/utilities/storage-manager';

import {
  retrieveAirportLiteNames,
  retrieveLanguageBundle,
  retrieveMenuPromotions,
  retrieveStoreFront,
  retrieveTravelInformation,
  setLanguage,
  setStoreFront,
} from '../redux/actions/index';

import {
  Billing,
  Home,
  Pnr,
  Iropsatc,
  Refund,
} from './urls';
import ProtectedRoutes from './ProtectedRoutes';
import RefundView from '../view/RefundView';
import BillingModal from '../scripts/components/global/billing/modal-billing';

const mapStateToProps = state => {
  return {
    errorLanguageBundle: state.LanguageBundle.errorLanguageBundle,
    languageBundle: state.LanguageBundle.languageBundle,
    loadingLanguageBundle: state.LanguageBundle.loadingLanguageBundle,
    loadingStoreFront: state.StoreFront.loadingStoreFront,
    storeFronts: state.StoreFront.storeFronts,
  };
};

class Router extends Component {
  constructor() {
    super();

    this.language = 'es';
    this.country = 'mx';

    this.state = {
      isGeneralLoading: true,
    };

    // gtag to enable the metrics in GA
    // eslint-disable-next-line no-undef
    gtag('consent', 'default', {
      'ad_storage': 'granted',
      'analytics_storage': 'granted',
      'ad_user_data': 'granted',
      'ad_personalization': 'granted',
      'wait_for_update': 500,
    });
    // gtag to enable the metrics in GA
    // eslint-disable-next-line no-undef
    gtag('js', new Date());
    // gtag to enable the metrics in GA
    // eslint-disable-next-line no-undef
    gtag('config', 'GTM-WGMM8LZ5');
    window.dataLayer.push({
      'event' : 'consent_default',
      'ad_storage': 'granted',
      'analytics_storage': 'granted',
      'ad_user_data': 'granted',
      'ad_personalization': 'granted',
      'wait_for_update': 500,
    });
    // gtag to enable the metrics in GA
    // eslint-disable-next-line no-undef
    gtag('consent', 'update', {
      'ad_storage': 'granted',
      'analytics_storage': 'granted',
      'ad_user_data': 'granted',
      'ad_personalization': 'granted',
    });
  }

  componentWillMount() {
    const { dispatch, storeFronts } = this.props;
    if (storeFronts.length === 0) {
      const storeFront = this.getStoreFront();
      const destructuringLanguage = storeFront.split('-');
      const language = destructuringLanguage[0];
      const country = destructuringLanguage[1];
      dispatch(retrieveStoreFront(language, country));
    }
  }

  componentWillReceiveProps(newProps) {
    const {
      errorLanguageBundle,
      languageBundle,
      loadingLanguageBundle,
      loadingStoreFront,
    } = newProps;

    if (Object.keys(languageBundle).length === 0 && !this.props.loadingLanguageBundle
      && !loadingLanguageBundle && !this.props.errorLanguageBundle && !errorLanguageBundle) {
      this.getLanguage();
    }

    const isLanguageBundleReady = Object.keys(languageBundle).length > 0;
    this.setState({
      isGeneralLoading: loadingStoreFront || loadingLanguageBundle || (!isLanguageBundleReady && !errorLanguageBundle),
    });
  }

  componentDidUpdate(prevProps) {
    const { dispatch, storeFronts } = this.props;

    if (storeFronts !== prevProps.storeFronts && storeFronts?.length && storeFronts?.length !== 0) {
      const storeFrontList = Array.isArray(storeFronts) ? storeFronts : [];
      const sfData = storeFrontList.find(sf => sf?.storefront?.identifier === this.getStoreFront());
      if (sfData && sfData.storefront && sfData.storefront.storefrontId) {
        dispatch(retrieveMenuPromotions(sfData.storefront.storefrontId));
        dispatch(retrieveTravelInformation(sfData.storefront.storefrontId));

        if (!storage.get('airportsLiteCMS')) {
          dispatch(retrieveAirportLiteNames(sfData.storefront.languageCode));
        }
      }
    }
  }

  render() {
    const { isGeneralLoading } = this.state;
    
    return (
      <div className='myb'>
        { isGeneralLoading ? (
          <div className='ManageOptionsTrip-loading'>
            <Loading
              copyIDList={ ['PO_LOAD_MSG1'] }
              seatmap={ false }
              isDataLoading={ true }
              type='airplaneWindow'
            />
          </div>
        ) : (
          <BrowserRouter>
            <Switch>
              <Route
                exact={ true }
                path={ Pnr(this.language, this.country) }
                component={ PnrForm }
              />
              <Route
                exact={ true }
                path={ Home(this.language, this.country) }
                render={ () => this.redirectToTrips() }
              />
              <Route
                exact={ true }
                path={ Refund(this.language, this.country) }
                render={ (props) => (
                  <ProtectedRoutes
                    { ...props }
                    guardPage={ false }
                    render={ (protectedRoutesProps) => <RefundView { ...props } { ...protectedRoutesProps } />}
                  />
                )}
              />
              <Route
                exact={ true }
                path={ Billing(this.language, this.country) }
                render={ (props) => (
                  <ProtectedRoutes
                    { ...props }
                    render={ (protectedRoutesProps) => (
                      <BillingModal
                        { ...props }
                        { ...protectedRoutesProps } 
                      />
                    )}
                  />
                )}
              />
              <Route
                exact={true}
                path={ Iropsatc(this.language, this.country) }
                render={ props => <IropsatcView {...props} /> }
              />
              <Route component={ PnrForm } />
            </Switch>
          </BrowserRouter>
        ) }
      </div>
    );
  }

  getLanguage() {
    const { dispatch } = this.props;

    const storeFront = this.getStoreFront();
    const destructuringLanguage = storeFront.split('-');

    dispatch(setStoreFront(storeFront));

    this.language = destructuringLanguage[0];
    this.country = destructuringLanguage[1];

    if (this.language === '') {
      this.language = 'es';
    }

    dispatch(setLanguage(this.language));

    return dispatch(retrieveLanguageBundle(this.language, storeFront, this.country));
  }

  getStoreFront() {
    const destructuringUrl = window.location.pathname;
    const regex = /\/(\w+)-(\w+)\//g;
    return destructuringUrl.match(regex) === null ? 'es-mx' : destructuringUrl.match(regex)[0].slice(1, -1);
  }

  /**
   * Redirects the Home route out of the /myb SPA basename towards the
   * storefront "trips" page, keeping everything before /trips/ from the
   * incoming URL (storefront + language segment) and the query params.
   * e.g. /myb/es-mx/administra-tu-viaje?last-name=aero&pnr=TOSGLB
   *   -> /es-mx/administra-tu-viaje/trips/?last-name=aero&pnr=TOSGLB
   */
  redirectToTrips() {
    const { protocol, host, pathname, search } = window.location;
    const basePath = pathname.replace(/^\/myb/, '').replace(/\/$/, '');
    const target = `${protocol}//${host}${basePath}/trips/${search}`;

    window.location.replace(target);

    return null;
  }
}

Router = connect(mapStateToProps)(Router);

export default Router;
